<template>
  <div class="c-main">
    <h3 class="c-title c-title--page-section">{{ $t('participation.edit') }}</h3>
    <participant :id="$route.params.participationId" :participantType="participantType"
                 @submit="update($event)" @remove="remove($event)" @cancel="cancel()" />
  </div>
</template>

<script>
export default {
  name: 'participation-view',
  components: {
    participant: require('./participation.vue').default,
  },
  computed: {
    participantType: function () {
      const participation = this.$store.state.participations.items.find(i => i.id === this.$route.params.participationId)
      console.log(participation)
      return participation.participantType
    },
  },
  methods: {
    update: function (data) {
      this.$notify.saveAsync(
        this.$t('participation'),
        this.$store.dispatch('participation.save', {data}),
        () => {
          this.$navigation.goto({name: 'event.discipline.participants'});
        }
      );
    },
    remove: function (id) {
      this.$notify.removeAsync(
        this.$t('participation'),
        this.$store.dispatch('participation.remove', {data: {id: id}}),
        () => {
          this.$navigation.goto({name: 'event.discipline.participants'});
        }
      );
    },
    cancel: function() {
      this.$navigation.goto({name: 'event.discipline.participants'})
    },
  }
};
</script>

<style>
</style>
